module.exports = __webpack_public_path__ + "static/img/ddz-icon.848c6848.png";